<style lang="scss" scoped>
  @import '../styles/helpers/main';
  @import '../styles/vars/main';
  .overlay {
    height: 100vh;
    background-color: color('white');
    width: 90%;
    max-width: 500px;
    position: fixed;
    right: 0;
    top: 0;
    padding: space('luxury') space('cozy');
    z-index: z-index('overlay');
    &.\--large {
      max-width: 1500px;
    }
    &__close {
      position: absolute;
      right: space('tight');
      top: space('tight');
      svg{
        @include svg-dim("base");
      }
    }
    &-enter-active, &-leave-active {
      transition: all 0.5s cubic-bezier(0.80, 0.20, 0.10, 1.00);
    }
    &-enter, &-leave-to {
      opacity: 0;
      transform: translateX(100%);
    }
  }
  .dimmer {
    position: absolute;
    z-index: 1;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    z-index: 799;
    background-color: rgba(color('black'), 0.6);
    cursor: pointer;
    &-enter-active, &-leave-active {
      transition: all 0.5s cubic-bezier(0.80, 0.20, 0.10, 1.00);
    }
    &-enter, &-leave-to {
      opacity: 0;
    }
  }
</style>
<template>
    <div>
      <transition name="overlay">
        <div v-show=overlay_isOpen class="overlay" :class="[{ '--large': overlay_content == 'photo' || overlay_content == 'settings' }, cssClass]">
          <v-button class="button-circle --grey overlay__close" @click.prevent="close">
            <svg>
              <use xlink:href="#close"></use>
            </svg>
          </v-button>
          <v-edit v-if="overlay_content == 'edit'"></v-edit>
          <v-create v-if="overlay_content == 'create'"></v-create>
          <v-photo v-if="overlay_content == 'photo'"></v-photo>
          <v-uploader v-if="overlay_content == 'uploader'"></v-uploader>
          <v-settings v-if="overlay_content == 'settings'"></v-settings>
        </div>
      </transition>
      <transition name="dimmer">
        <div class="dimmer" v-show=overlay_isOpen :class="[cssClass]" @click="close"></div>
      </transition>
    </div>
</template>
<script>
import Edit from '../components/album/edit';
import Create from '../components/album/create';
import Photo from '../components/album/photo';
import Uploader from '../components/album/uploader';
import Settings from '../components/album/settings';
import Button from './button';
import { mapGetters } from 'vuex';

export default {
  name: 'overlay',
  components: {
    'v-edit': Edit,
    'v-create': Create,
    'v-photo': Photo,
    'v-button': Button,
    'v-uploader': Uploader,
    'v-settings': Settings
  },
  data() {
    return {

    };
  },
  props: {
    cssClass: {
      type: String,
      default: ''
    }
  },
  mounted() {

  },
  computed: {
    ...mapGetters([
      'overlay_isOpen',
      'overlay_content',
      'activeId'
    ])
  },
  methods: {
    close() {
      this.$store.commit('overlay_isOpen', false);
    }
  },
  watch: {
    // overlay_isOpen: function() {
    //   if (this.overlay_isOpen === false) {
    //     this.$store.commit('overlay_content', '');
    //   }
    // }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/overlay.vue